import { render } from "./CadastroTipoPessoasView.vue?vue&type=template&id=2707a0a4&scoped=true"
import script from "./CadastroTipoPessoasView.vue?vue&type=script&lang=js"
export * from "./CadastroTipoPessoasView.vue?vue&type=script&lang=js"

import "./CadastroTipoPessoasView.vue?vue&type=style&index=0&id=2707a0a4&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2707a0a4"]])

export default __exports__